import React from 'react';
import PropTypes from 'prop-types';
import UI from './ProfileViewToolbar.ui';
import analytics, * as trackingTypes from '../../actions/analyticsActions';
import { publishProfile, unpublishProfile } from '../../actions/profileActions';
import { connect } from 'react-redux';

class ProfileViewToolbar extends React.Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        isProfileOwner: PropTypes.bool,
        profile: PropTypes.object.isRequired,
    };

    onEditProfile = () => {
        this.props.dispatch(
            analytics(trackingTypes.EDIT_CLICK, {
                profile: this.props.profile.profile,
            })
        );
    };

    onRequestPublish = () => {
        this.props.dispatch(publishProfile(this.props.profile.profile));
    };

    onRequestUnpublish = () => {
        this.props.dispatch(unpublishProfile(this.props.profile.profile));
    };

    render() {
        return (
            <UI
                isProfileOwner={this.props.isProfileOwner}
                onEditProfile={this.onEditProfile}
                onRequestPublish={this.onRequestPublish}
                onRequestUnpublish={this.onRequestUnpublish}
                profile={this.props.profile}
            />
        );
    }
}

export default connect((state) => ({ profile: state.profile }))(
    ProfileViewToolbar
);
